module.exports = __webpack_public_path__ + "static/media/SUNTV.0b699ffa.txt";